import {
  EmailSendModal,
  InspectionFormModal,
  InspectionTenantCategorySelect,
  SharedTable,
} from '@components';
import { IInspectionsHook } from '@models';
import { InspectionCategory } from '@services';
import { Alert, Col, Row, Table } from 'antd';
import React, { useState } from 'react';
import { Columns } from './OrderInspectionTable.columns';
import { OrderInspectionPrintModal } from './OrderInspectionPrintModal';

interface TableProps {
  open: boolean;
  readOnly?: boolean;
  inspectionId: string | null;
  inspectionsHook: IInspectionsHook;
  selectedInspections: InspectionCategory[];
  vhcEmailModalOpen: boolean;
  vhcEmail: string;
  vhcEmailError: string | null;
  vhcEmailSending: boolean;
  handleClose: () => void;
  handleOpen: (id: string) => void;
  handlePublish: (id: string) => void;
  handleVhcEmailOpen: (id: string) => void;
  handleAddInspection: (categoryId: number) => void;
  handleDeleteInspection: (categoryId: number) => void;
  setSelectedInspections: (inspection: InspectionCategory[]) => void;
  handleVhcEmailChange: (val: string) => void;
  handleVhcEmailSend: () => void;
  handleVhcEmailCancel: () => void;
}

const OrderInspectionTable: React.FC<TableProps> = ({
  open,
  readOnly,
  inspectionId,
  inspectionsHook,
  selectedInspections,
  vhcEmailModalOpen,
  vhcEmail,
  vhcEmailError,
  vhcEmailSending,
  handleClose,
  handleOpen,
  handlePublish,
  handleVhcEmailOpen,
  handleAddInspection,
  handleDeleteInspection,
  setSelectedInspections,
  handleVhcEmailChange,
  handleVhcEmailSend,
  handleVhcEmailCancel,
}) => {
  const [printInspectionId, setPrintInspectionId] = useState<string | null>(null);

  return (
    <>
      {!readOnly && (
        <>
          <Alert
            message="Publishing inspection will make it visible to the mobile app user and automatically generate an internal service request for the garage manager to review and process."
            type="info"
            showIcon
            style={{ marginBottom: 16 }}
          />
          <p style={{ fontSize: '14px', fontWeight: 700, color: 'rgba(0, 0, 0, 0.85)', marginTop: '0px' }}>
            Inspections
          </p>
          <Row>
            <Col span={24}>
              <InspectionTenantCategorySelect
                selectedInspections={selectedInspections}
                setSelectedInspections={setSelectedInspections}
                handleSelect={handleAddInspection}
                handleDeselect={handleDeleteInspection}
              />
            </Col>
          </Row>
          <br />
        </>
      )}
      <SharedTable
        {...inspectionsHook}
        columns={Columns({
          handleEdit: handleOpen,
          handlePublish,
          handleVhcEmailOpen,
          handlePrint: (id) => setPrintInspectionId(id),
        })}
        summary={() => (
          <Table.Summary fixed="top">
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} />
              <Table.Summary.Cell index={1} />
              <Table.Summary.Cell index={2} />
            </Table.Summary.Row>
          </Table.Summary>
        )}
      />
      {inspectionId && (
        <InspectionFormModal open={open} onCancel={handleClose} inspectionId={inspectionId} />
      )}
      <OrderInspectionPrintModal
        inspectionId={printInspectionId}
        onDone={() => setPrintInspectionId(null)}
      />
      <EmailSendModal
        open={vhcEmailModalOpen}
        title="Send inspection email"
        emailValue={vhcEmail}
        setEmailValue={handleVhcEmailChange}
        emailError={vhcEmailError}
        onConfirm={handleVhcEmailSend}
        onCancel={handleVhcEmailCancel}
        confirmText="Send"
        okButtonProps={{ disabled: !!vhcEmailError, loading: vhcEmailSending }}
      />
    </>
  );
};

export default OrderInspectionTable;
